import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './components/doctor/layout/Calendar.css';
import './components/doctor/layout/doctor.css';
import './components/vaccine/layout/appointmentInfo.css';
import './components/vaccine/layout/vaccine.css';
import './components/findDoctor/layout/findDoctor.css'
import './components/mainScreen/layout/mainScreen.css'
import './components/privacy/layout/privacy.css'
import 'react-medium-image-zoom/dist/styles.css'
import './App.css'

import reportWebVitals from './reportWebVitals';
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
